import { extendObservable, action } from 'mobx';
import { browserHistory } from 'react-router';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import omit from 'lodash/omit';
import toInteger from 'lodash/toInteger';

export default class ModuleFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      moduleId: null,
    });
    this.form.validations = {
      name: [isRequired],
      course: [isRequired],
      group: [isRequired],
      order: [isRequired],
    };
  }

  handleLoad = action((moduleId) => {
    this.form.reset();
    if (moduleId) {
      this.fetch
        .fetch({
          url: `/modules/${moduleId}?verbose=true`,
        })
        .then(() => {
          if (this.fetch.data) {
            this.form.setInitialValues({
              ...omit(this.fetch.data, ['academicPlan']),
              course: this.fetch.data.course.id,
              isCustomCourse: !!this.fetch.data.course.distributor,
            });

            this.form.validations.readingPoints = [isRequired];
            this.form.validations.listeningPoints = [isRequired];
            this.form.validations.speakingPoints = [isRequired];
            this.form.validations.writingPoints = [isRequired];
          }
        });
    } else {
      this.form.setInitialValues({});
    }
    this.moduleId = moduleId;
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    const moduleId = this.form.getValue('id');

    if (moduleId) {
      const readingPoints = toInteger(this.form.getValue('readingPoints'));
      const listeningPoints = toInteger(this.form.getValue('listeningPoints'));
      const speakingPoints = toInteger(this.form.getValue('speakingPoints'));
      const writingPoints = toInteger(this.form.getValue('writingPoints'));
      if (
        this.form.getValue('isCustomCourse') &&
        !readingPoints &&
        !listeningPoints &&
        !speakingPoints &&
        !writingPoints
      ) {
        NotificationService.addNotification('Please set at least one ability points', 'error');
        return;
      }
      if (
        !this.form.getValue('isCustomCourse') &&
        (!readingPoints || !listeningPoints || !speakingPoints || !writingPoints)
      ) {
        NotificationService.addNotification('Please set all ability points', 'error');
        return;
      }
    }

    this.submit
      .fetch({
        method: moduleId ? 'put' : 'post',
        url: moduleId ? `/modules/${moduleId}` : '/modules',
        body: {
          ...this.form.getValues(),
          ...(this.form.getValue('createdBy') && {
            createdBy: this.form.getValue('createdBy.id'),
          }),
        },
      })
      .then(() => {
        if (this.submit.data) {
          browserHistory.push('/modules');
          NotificationService.addNotification(`Module ${moduleId ? 'updated' : 'created'} successfully.`, 'success');
        }
        if (this.submit.error) {
          NotificationService.addNotification(`Error ${moduleId ? 'updating' : 'creating'} module.`, 'error');
        }
      });
  });
}
